import { ThemeToggle } from "@/components/layout/ThemeToggle";
import { GoogleCalendarConnectionCard } from "@/components/settings/GoogleCalendarConnectionCard";
import { PageHeader } from "@/components/shared/page-header";
import { Card, CardContent } from "@/components/ui/card";

// Single-user app — no admin/user-management, no system/email tabs. Just the
// one preference worth surfacing, plus the admin-only Google Calendar
// connection card (EPIC-013 — hidden entirely for a non-admin session). The
// Audit Log viewer (/dashboard/settings/audit) stays mounted but
// intentionally unlinked from here (see .claude/rules/audit.md).
export function SettingsPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Settings" description="Manage your app preferences." />
      <Card className="border-border/50">
        <CardContent className="flex items-center justify-between py-4">
          <div>
            <p className="text-sm font-medium">Theme</p>
            <p className="text-sm text-muted-foreground">Switch between light and dark mode.</p>
          </div>
          <ThemeToggle />
        </CardContent>
      </Card>
      <GoogleCalendarConnectionCard />
    </div>
  );
}
